import { render, staticRenderFns } from "./provider-companyoverview.vue?vue&type=template&id=97adde1a&scoped=true"
import script from "./provider-companyoverview.vue?vue&type=script&lang=js"
export * from "./provider-companyoverview.vue?vue&type=script&lang=js"
import style0 from "./provider-companyoverview.vue?vue&type=style&index=0&id=97adde1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97adde1a",
  null
  
)

export default component.exports